import sortBy from 'lodash/sortBy';
import { DataTable, DataTableSortStatus } from 'mantine-datatable';
import { useEffect, useMemo, useState } from 'react';
import { Box, Button, Divider, Menu, Text, Flex } from "@mantine/core";
import { MantineReactTable, useMantineReactTable } from 'mantine-react-table';
import FieldDepth from '../FieldDepth';

const Compare = (props) => {
    const [loading, setLoading] = useState();
    const [teams, setTeams] = useState();
    const [stats, setStats] = useState();
    const [currentField, setCurrentField] = useState();

    const fieldDepthAction = (internalColumnMenuItems, field) => {
        return (
            <>
                <Menu.Item onClick={() => {
                    console.log(field)
                    setCurrentField(field)
                }}>
                    <Text color='green' weight="bold">Show Field Depth</Text>
                </Menu.Item>
                <Divider />
                {internalColumnMenuItems}
            </>
        )
    }

    const columns = useMemo(
        () => [
            {
                accessorKey: 'team',
                header: "Team",
            },
            {
                accessorKey: "totalPoints",
                header: "Total Points",
                renderColumnActionsMenuItems: ({ internalColumnMenuItems }) => (
                    fieldDepthAction(internalColumnMenuItems, "totalPoints")
                ),
            },
            {
                accessorKey: 'autoPoints',
                header: "Auto Pts Avg",
                renderColumnActionsMenuItems: ({ internalColumnMenuItems }) => (
                    fieldDepthAction(internalColumnMenuItems, "autoPoints")
                ),
            },
            {
                accessorKey: "autoFuel",
                header: "Auto Fuel",
                renderColumnActionsMenuItems: ({ internalColumnMenuItems }) => (
                    fieldDepthAction(internalColumnMenuItems, "autoFuel")
                ),
            },
            {
                accessorKey: "autoMissedFuel",
                header: "Auto Missed",
                renderColumnActionsMenuItems: ({ internalColumnMenuItems }) => (
                    fieldDepthAction(internalColumnMenuItems, "autoMissedFuel")
                ),
            },
            {
                accessorKey: "autoShuttledFuel",
                header: "Auto Shuttled",
                renderColumnActionsMenuItems: ({ internalColumnMenuItems }) => (
                    fieldDepthAction(internalColumnMenuItems, "autoShuttledFuel")
                ),
            },
            {
                accessorKey: "autoFuelClusters",
                header: "Auto Clusters",
                renderColumnActionsMenuItems: ({ internalColumnMenuItems }) => (
                    fieldDepthAction(internalColumnMenuItems, "autoFuelClusters")
                ),
            },
            {
                accessorKey: 'teleopPoints',
                header: "Teleop Pts Avg",
                renderColumnActionsMenuItems: ({ internalColumnMenuItems }) => (
                    fieldDepthAction(internalColumnMenuItems, "teleopPoints")
                ),
            },
            {
                accessorKey: "teleopFuel",
                header: "Teleop Fuel",
                renderColumnActionsMenuItems: ({ internalColumnMenuItems }) => (
                    fieldDepthAction(internalColumnMenuItems, "teleopFuel")
                ),
            },
            {
                accessorKey: "teleopMissedFuel",
                header: "Teleop Missed",
                renderColumnActionsMenuItems: ({ internalColumnMenuItems }) => (
                    fieldDepthAction(internalColumnMenuItems, "teleopMissedFuel")
                ),
            },
            {
                accessorKey: "teleopShuttledFuel",
                header: "Teleop Shuttled",
                renderColumnActionsMenuItems: ({ internalColumnMenuItems }) => (
                    fieldDepthAction(internalColumnMenuItems, "teleopShuttledFuel")
                ),
            },
            {
                accessorKey: "teleopFuelClusters",
                header: "Teleop Clusters",
                renderColumnActionsMenuItems: ({ internalColumnMenuItems }) => (
                    fieldDepthAction(internalColumnMenuItems, "teleopFuelClusters")
                ),
            },
            {
                accessorKey: "totalFuelScored",
                header: "Total Fuel",
                renderColumnActionsMenuItems: ({ internalColumnMenuItems }) => (
                    fieldDepthAction(internalColumnMenuItems, "totalFuelScored")
                ),
            },
            {
                accessorKey: 'endgamePoints',
                header: "Endgame Pts Avg",
                renderColumnActionsMenuItems: ({ internalColumnMenuItems }) => (
                    fieldDepthAction(internalColumnMenuItems, "endgamePoints")
                ),
            },
            {
                accessorKey: "autoClimbStatus",
                header: "Auto Climb",
                renderColumnActionsMenuItems: ({ internalColumnMenuItems }) => (
                    fieldDepthAction(internalColumnMenuItems, "autoClimbStatus")
                ),
            },
            {
                accessorKey: "endgameClimbStatus",
                header: "Endgame Climb",
                renderColumnActionsMenuItems: ({ internalColumnMenuItems }) => (
                    fieldDepthAction(internalColumnMenuItems, "endgameClimbStatus")
                ),
            },
            {
                accessorKey: 'driverRating',
                header: "Driver Rating",
                renderColumnActionsMenuItems: ({ internalColumnMenuItems }) => (
                    fieldDepthAction(internalColumnMenuItems, "driverRating")
                ),
            },
            {
                accessorKey: 'defenseRating',
                header: "Defense Rating",
                renderColumnActionsMenuItems: ({ internalColumnMenuItems }) => (
                    fieldDepthAction(internalColumnMenuItems, "defenseRating")
                ),
            },
            {
                accessorKey: 'intakeRating',
                header: "Intake Rating",
                renderColumnActionsMenuItems: ({ internalColumnMenuItems }) => (
                    fieldDepthAction(internalColumnMenuItems, "intakeRating")
                ),
            },
            {
                accessorKey: 'climbRating',
                header: "Climb Rating",
                renderColumnActionsMenuItems: ({ internalColumnMenuItems }) => (
                    fieldDepthAction(internalColumnMenuItems, "climbRating")
                ),
            },
            {
                accessorKey: "died",
                header: "Died",
                renderColumnActionsMenuItems: ({ internalColumnMenuItems }) => (
                    fieldDepthAction(internalColumnMenuItems, "died")
                ),
            },
            {
                accessorKey: "tipped",
                header: "Tipped",
                renderColumnActionsMenuItems: ({ internalColumnMenuItems }) => (
                    fieldDepthAction(internalColumnMenuItems, "tipped")
                ),
            }
        ],
        [],
    );

    useEffect(() => {
        setLoading(true);
    }, []);

    useEffect(() => {
        setLoading(true);
    }, [props.event]);

    useEffect(() => {
        const asyncFunction = async () => {
            const getTeams = async (event) => {
                let array = [];
                await fetch(`https://www.thebluealliance.com/api/v3/event/${event}/teams/simple`, {
                    headers: { "X-TBA-Auth-Key": "fLKsnM61nLrIA7CDpmFybAXvRYFeCQbIRrPYm5sKSSrs77vsUhL2whnLIHizc3iU" }
                })
                    .then((response) => response.json())
                    .then((data) => {
                        data.forEach(element => {
                            array.push(element.key.replace("frc", ""));
                        });
                    });
                return array;
            }
            let local = await getTeams(props.event);
            setTeams(local);
        }
        asyncFunction();
    }, [loading, props.event]);

    useEffect(() => {
        const asyncFunction = async () => {
            const getStats = async () => {
                let array = [];
                for (var i in teams) {
                    await fetch(`https://server.palyrobotics.com/team/${props.event}/${teams[i]}`, {
                        headers: { "X-TBA-Auth-Key": "fLKsnM61nLrIA7CDpmFybAXvRYFeCQbIRrPYm5sKSSrs77vsUhL2whnLIHizc3iU" }
                    })
                        .then((response) => response.json())
                        .then((data) => {
                            var record = {
                                team: teams[i],
                                totalFuelScored: (data.average.autoFuel || 0) + (data.average.teleopFuel || 0),
                                ...data.average
                            }
                            // Round all numeric values
                            Object.keys(record).map((key) => {
                                if (typeof record[key] === 'number') {
                                    record[key] = Math.round(record[key] * 100) / 100
                                }
                            })
                            array.push(record);
                        });
                }
                console.log(array)
                return array;
            }

            if (teams && teams.length > 0) {
                let local = await getStats();
                console.log(local)
                setStats(local);
                setLoading(false);
            }
        }
        asyncFunction();
    }, [teams, props.event]);

    if (loading) {
        return <div className="container">Loading... this may take some time</div>
    }

    return (
        <>
            {currentField &&
                <Flex direction="column" align="center">
                    <FieldDepth field={currentField} data={stats} />
                    <Button color='green.4' variant='subtle' onClick={() => {
                        setCurrentField("")
                    }}>Hide Field Depth</Button>
                </Flex>
            }
            <MantineReactTable
                columns={columns}
                data={stats ? stats : []}
                state={{ isLoading: false }}
            />
        </>
    );
}

export default Compare;